import React from 'react';
import { ModuleBase, Stack, HeadingTag, ResponsiveImage } from '@/components';
import { SideBySideModuleModel } from './SideBySideModule';

const HomepageHero = (data: SideBySideModuleModel) => {
  const {
    props: { image, title, media },
  } = data;

  return (
    <ModuleBase data={data} noPadding className="HomepageHero relative h-svh overflow-hidden lg:h-screen">
      {media && (
        <video
          playsInline
          webkit-playsinline="true"
          autoPlay
          muted
          loop
          controlsList="nodownload"
          preload="auto"
          className="absolute top-0 right-0 left-0 hidden h-full w-full object-cover md:block"
          src={media}
        />
      )}

      {!media && image && image.desktopImage && (
        <ResponsiveImage
          image={image.desktopImage}
          widths={{ xs: 425, sm: 1024, md: 1024, lg: 1280, xl: 1440, xxl: 2560 }}
          heights={{ xs: 750, sm: null, md: null, lg: null, xl: null, xxl: null }}
          dataNotLazy
          preload
          cdnProps={{ mode: 'crop' }}
          className="absolute top-0 right-0 left-0 hidden h-full w-full sm:block"
        />
      )}

      {image && image.mobileImage && (
        <ResponsiveImage
          image={image.mobileImage}
          widths={{ xs: 425, sm: 1 }}
          heights={{ xs: 750, sm: null }}
          dataNotLazy
          preload
          cdnProps={{ mode: 'crop' }}
          className="absolute top-0 right-0 left-0 h-full w-full sm:hidden"
        />
      )}

      <div className="relative h-full w-full">
        <Stack className="container mx-auto flex h-full flex-col justify-end">
          <div className="w-full xl:w-3/4">
            {title && (
              <HeadingTag
                tag="h1"
                heading={title}
                role="contentinfo"
                aria-label="contentinfo"
                dontAddClassFromTag
                className="text-style-h1 pb-5 text-white md:pb-10 xl:pb-18"
              />
            )}
          </div>
        </Stack>
      </div>
    </ModuleBase>
  );
};

export default HomepageHero;
